import { cx } from '@onbeam/business-styled-system/css';
import { text } from '@onbeam/business-styled-system/patterns';
import { PropsWithChildren } from 'react';

export const MenuTitle = ({
  children,
  className,
}: PropsWithChildren<{ className?: string }>) => (
  <div
    className={cx(
      text({
        px: '4',
        pb: '1',
        pt: '3',
        style: 'small-sm',
        fontWeight: 'bold',
        color: 'mono.tertiary',
      }),
      className,
    )}
  >
    {children}
  </div>
);
